const BANNER_KEY_PREFIX = 'bannerstartautoplay';

export function getBannerStartAutoplayEventKey(bannerGroupId: string) {
  return `${BANNER_KEY_PREFIX}_${bannerGroupId}`;
}
